/*
 * @Author: Thorn Youzijia555@outlook.com
 * @Date: 2023-05-04 13:51:00
 * @LastEditors: Thorn Youzijia555@outlook.com
 * @LastEditTime: 2024-08-11 11:32:11
 * @FilePath: \shnu.admission-office.management\src\api\exam\index.ts
 * @Description:
 *
 * Copyright (c) 2024 by Thorn.Y, All Rights Reserved.
 */
import { axios } from '@/utils/http'
import { Exam, BaseExam } from '@/models/exam'
import { TableResponse, Params } from '@/components/table'
import { paramsApdapter } from '@/utils/apdapter'

export async function get(id: string): Promise<Exam>
export async function get(params?: Params): Promise<TableResponse<Exam>>
export async function get(params?: string | Params) {
  const handle =
    typeof params === 'string'
      ? axios.get(`exam/${params}`)
      : axios.get(`exam`, { params: paramsApdapter(params) })
  const { data } = await handle
  return data
}

export async function post(exam: BaseExam) {
  const { data } = await axios.post(`exam`, exam)
  return data as Exam
}

export async function bak(examid: string) {
  await axios.post(`exam/bak/${examid}`)
}
